import Vue from 'PublicJs/vue-bootstrap';
import MailingLists from 'PublicJs/MailingLists/components/MailingLists';

new Vue({
	el: '#mailing-lists-app',
	components: {
		MailingLists
	}
});
